import React from 'react'

/*
  <SetItemPlusMinus 
    plusMinus={props.activeItems[props.itemId] ? 'minus' : 'plus'} 
    handleAddContentToSet={props.handleAddContentToSet}
    itemId={props.itemId}
    handleRemoveContentFromSet={props.handleRemoveContentFromSet}
  />
*/

export default function SetItemPlusMinus(props) {
  if (props.plusMinus === 'plus') {
    return (
      <i className='fa fa-plus m2clickable' onClick={() => props.handleAddContentToSet(props.itemId)}></i>
    )
  } else if (props.plusMinus === 'minus') {
    return (
      <i className='fa fa-minus m2clickable' onClick={() => props.handleRemoveContentFromSet(props.itemId)}></i>
    )
  } else {
    return <i></i>
  }
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemPlusMinus.js